import { Component, OnInit } from '@angular/core';
import { Invite } from '@models/Core/Invite';
import { Session } from '@models/Sessions/Session';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SessionsRequestService } from '@services/sessions/sessions.request.service';
import { UserInviteService } from '@services/users/invite.service';

@Component({
  selector: 'app-revoke-invite-dialog',
  templateUrl: './revoke-invite-dialog.component.html',
  styleUrls: ['./revoke-invite-dialog.component.scss'],
})
export class RevokeInviteDialogComponent implements OnInit {
  invite: Invite;
  sessions: Session[];
  changed = false;

  constructor(
    private sessionService: SessionsRequestService,
    private invietService: UserInviteService,
    public activeModal: NgbActiveModal,
  ) {}

  ngOnInit() {
    this.sessionService.getAll().subscribe(sessions => {
      this.sessions = sessions;
    });
  }

  dismiss() {
    this.activeModal.close(this.changed);
  }

  get revokableSessions() {
    if (this.invite && this.sessions) {
      return this.invite.sessions
        .map(s => {
          const session = this.sessions.find(
            session => session._id.toString() === s.session,
          );
          if (
            session &&
            session.me.can_invite &&
            (session.me.role <= s.role ||
              session.me.user_id === this.invite.created_by)
          ) {
            (session as any).canRevoke = session.me.role <= s.role;
          }
          return session;
        })
        .filter(s => !!s);
    } else {
      return [];
    }
  }

  revoke(session: Session) {
    this.invietService.uninvite(session, this.invite).subscribe(() => {
      this.invite.sessions = this.invite.sessions.filter(
        s => s.session !== session._id.toString(),
      );
      this.changed = true;
      if (this.invite.sessions.length === 0) {
        this.dismiss();
      }
    });
  }
}
